import { Box, Container, Flex, Text, Divider, SimpleGrid, Input, FormControl, FormLabel, Select, ButtonGroup, Button, FormErrorMessage, FormHelperText } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import Layout from "scenes/layouts";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik } from "formik";
import LogosNotification from "utils/notification-utils";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import BannerService from "../../services/banners/banner-service";

const today = new Date();

const formInitialValue = {
    name: '',
    redirectUrl: '',
    checkoutUrl: '',
    isRedirectToNewWindow: false,
    posterImage: null
};

const NewBannerScene = (): ReactElement => {
    const navigate = useNavigate();
    const [isSaving, setSaving] = useState<boolean>(false);
    const [formValue, setFormValue] = useState<any>(formInitialValue);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        BannerService.Create(
            values.name,
            values.redirectUrl,
            values.checkoutUrl,
            values.isRedirectToNewWindow,
            values.posterImage
        ).then((res: any) => {
            LogosNotification.Success("Banner berhasil dibuat.");
            navigate(`/banners/${res.result.id}`);
        }).finally(() => {
            setSaving(false);
        });
    };

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={'3xl'} fontWeight={"bold"}>Buat Banner Baru</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama Banner</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Banner'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Banner wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.redirectUrl && touched.redirectUrl)}>
                                                    <FormLabel htmlFor='redirectUrl'>Redirect Url</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='redirectUrl'
                                                        placeholder='Redirect Url'
                                                        name={'redirectUrl'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Redirect Url wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.redirectUrl}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.checkoutUrl && touched.checkoutUrl)}>
                                                    <FormLabel htmlFor='checkoutUrl'>Checkout Url</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='checkoutUrl'
                                                        placeholder='Checkout Url'
                                                        name={'checkoutUrl'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Checkout Url wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.checkoutUrl}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.isRedirectToNewWindow && touched.isRedirectToNewWindow)}>
                                                    <FormLabel htmlFor='isRedirectToNewWindow'>Buka Halaman Baru?</FormLabel>
                                                    <Field
                                                        type="checkbox"
                                                        id='isRedirectToNewWindow'
                                                        name={'isRedirectToNewWindow'}
                                                        checked={values.isRedirectToNewWindow}
                                                        style={{ width: '22px', height: '22px' }}
                                                    >
                                                    </Field>
                                                    <FormErrorMessage>{errors.isRedirectToNewWindow}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.posterImage && touched.posterImage)}>
                                                    <FormLabel htmlFor='screenshot'>Gambar Banner</FormLabel>
                                                    <input
                                                        type={'file'}
                                                        id='posterImage'
                                                        name={'posterImage'}
                                                        accept="image/*"
                                                        onChange={(event: any) => {
                                                            setFieldValue("posterImage", event.currentTarget.files[0]);
                                                        }}
                                                    />
                                                    <FormHelperText>Ukuran: 1280 x 720 px</FormHelperText>
                                                    <FormErrorMessage>{errors.posterImage}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Divider mt={4} />

                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} onClick={() => { navigate('/banners') }}>Kembali</Button>
                                            </ButtonGroup>
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default NewBannerScene;